export default {
  portfolio: {
    // Hierarchy-based universe rules (R-04/R-06/R-07, §90 phase 2B)
    scopesTitle: "Universe rules",
    scopesNone: "no rules · manual entries only",
    scopesCount: "{n} rules · {cn} CN",
    scopesHintPortfolio: "Anything matching a rule counts as your own product, today and whenever a new CN appears. Example: your marketing-authorisation holder.",
    scopesHintCompetitor: "Anything matching a rule counts as competition (except what is already yours). Example: an active ingredient, an ATC code or a homogeneous group.",
    scopeKind_lab: "Holder laboratory",
    scopeKind_pa: "Active ingredient",
    scopeKind_atc: "ATC code (prefix)",
    scopeKind_ah: "Homogeneous group",
    scopeKind_spr: "Reference-price set",
    scopeKind_nregistro: "Registration no.",
    scopePlaceholder_lab: "e.g. Normon",
    scopePlaceholder_pa: "e.g. Olmesartan",
    scopePlaceholder_atc: "e.g. C09CA",
    scopePlaceholder_ah: "group code or name",
    scopePlaceholder_spr: "e.g. F206",
    scopeCn: "{n} CN",
    scopeAdd: "Add rule",
    scopeRemove: "Remove rule",
    myProducts: "My Products ({n})",
    competitors: "Competitors ({n})",
    saved: "Saved",
    bulkRemoveProducts: "Remove the {n} shown",
    bulkRemoveCompetitors: "Remove the {n} shown",
    bulkRemoveProductsTitle: "Remove {n} products from My products?",
    bulkRemoveCompetitorsTitle: "Remove {n} products from Competitors?",
    bulkRemoveMessage: "The ones shown with the current filters are removed. Their events stay in the history. Those that come from a universe rule will keep coming while the rule exists.",
    bulkRemoved: "{n} removed",
    errorPrefix: "Error: ",
    searchPlaceholder: "Search…",
    allTypes: "All types",
    allAreas: "All areas",
    allLabs: "All laboratories",
    filterNoPresentation: "No presentation marketed",
    filterCo02: "Not marketed for 30 months or more",
    noPresentationSince: "No presentation since {date} · {n} months",
    noPresentationAut: "No presentation of this authorisation has been marketed since it was granted. After 3 years the authorisation may lapse (art. 28 RD 1345/2007).",
    noPresentationCese: "No presentation of this authorisation has been marketed since marketing last ceased. After 3 years the authorisation may lapse (art. 28 RD 1345/2007).",
    allStatuses: "All statuses",
    emptyFiltered: "No products match the filters",
    emptyFilteredCompetitors: "No competitors match the filters",
    typeDirect: "Direct",
    typeTherapeutic: "Therapeutic",
    colProduct: "Product",
    colActiveIngredient: "Active Ingr.",
    colTherapeuticArea: "Therapeutic Area",
    colLaboratory: "Laboratory",
    colStatus: "Status",
    colType: "Type",
    colCompany: "Company",
    viewSheetOf: "View details for {name}",
    newToMarket: "New to market",
    newToMarketTooltip: "HelixScan added it to your competitors on {date}: it entered the market on your active ingredient {ingredient}.",
    parallelTitle: "Parallel imports",
    parallelPending: "{n} parallel imports awaiting your decision",
    parallelPendingOne: "1 parallel import awaiting your decision",
    parallelIntro: "These are presentations authorised in another EU country and marketed in Spain by a third party: their registration number has the IP suffix or is foreign. The catalogue treats them as competitors (AP-08), and they count as such until you decide. Decide one by one or select several.",
    parallelReview: "Review",
    parallelHide: "Hide",
    parallelColRegistro: "Registration no.",
    parallelColTitular: "Holder",
    parallelColOfertante: "Marketed by",
    parallelColDecision: "Treated as",
    parallelMotivoIp: "IP suffix",
    parallelMotivoForeign: "Foreign registration",
    parallelPendingLabel: "Pending · competitor",
    parallelOwn: "Own",
    parallelCompetitor: "Competitor",
    parallelMarkOwn: "Treat as own",
    parallelMarkCompetitor: "Treat as competitors",
    parallelSelected: "{n} selected",
    parallelSaved: "Decision saved",
    parallelChip: "Parallel import",
    parallelChipTooltip: "Parallel import (foreign registration number or IP suffix). Decide in My products whether it is your own.",
    statusActive: "Active",
    statusInactive: "Inactive",
    actionViewSheet: "View details",
    actionDeleteProduct: "Delete product",
    actionDeleteCompetitor: "Delete competitor",
    emptyProducts: "No products",
    emptyCompetitors: "No competitors",
    confirmDeleteProductTitle: "Delete product?",
    confirmDeleteCompetitorTitle: "Delete competitor?",
    confirmDeleteMessage: "This action cannot be undone.",
    modalAddProduct: "Add product",
    modalAddCompetitor: "Add competitor",
    fieldCnRequired: "CN code *",
    fieldProductNameRequired: "Product name *",
    fieldActiveIngredientRequired: "Active substance *",
    fieldLaboratory: "Laboratory",
    fieldTherapeuticArea: "Therapeutic area",
    fieldCn: "CN code",
    cnPlaceholder: "e.g. 123456",
    fieldCompetitorType: "Competitor type",
    competitorTypeDirect: "Direct (same active substance)",
    competitorTypeTherapeutic: "Therapeutic (same indication)",
    fieldCompany: "Company",
    fieldProduct: "Product",
    cancel: "Cancel",
    save: "Save",
  },
};
